module.exports = [{
      plugin: require('/Users/rbanate/projects/personal/glianeoptical/gatsby-browser.js'),
      options: {"plugins":[]},
    }]
